import { IRefreshMinersProps } from "./RefreshMiners.props";
import { useRefreshMinersControl } from "./useRefreshMinersControl";
import RefreshBtn from "@components/global/new/RefreshBtn/RefreshBtn";

export default function RefreshMiners({ ...props }: IRefreshMinersProps) {
  const control = useRefreshMinersControl(props);
  return <RefreshBtn loading={control.loading} onClick={control.onRefresh} className={props.className}/>;
}
